var _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIc35(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    width: "12.6999mm",
    height: "5.6469mm",
    shapeRendering: "geometricPrecision",
    textRendering: "geometricPrecision",
    imageRendering: "optimizeQuality",
    fillRule: "evenodd",
    clipRule: "evenodd",
    viewBox: "0 0 12700 5646.9",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u0421\\u043B\\u043E\\u0439_x0020_1"
  }, /*#__PURE__*/React.createElement("metadata", {
    id: "CorelCorpID_0Corel-Layer"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    fillRule: "nonzero",
    d: "M3103.5 444.4c363.5,291.7 575.2,732.9 575.2,1198.8 0,35.1 -1.3,70.6 -3.6,105.5 2.6,39.5 4.4,79.7 4.4,119.4 0,488.2 -221.7,950.7 -602.3,1256.2 -429,294.9 -937.8,453 -1458.6,453 -42.7,0 -86.4,-1.3 -128.9,-3.1l-711.8 0.1 0 2071.7 -777.9 0 0 -5641 1481.7 0c54,-3.1 109,-5 163.3,-5 519.4,0 1027.7,154.9 1458.7,444.4l-0.1 -0.1 -0.1 0.1zm-611.2 2254.2c238,-174.6 357.2,-489.5 357.2,-941.9 2.8,-30.9 4.2,-61.8 4.2,-92.7 0,-301.3 -132.2,-587.5 -361.4,-783.1 -269.2,-175.1 -584.1,-268.4 -905.4,-268.4 -37.7,0 -75.7,1.4 -113.2,3.9l-695.9 -0.1 0 2349.5 680 0c34.9,2 70.6,3.1 105.7,3.1 328.9,0 651.5,-94 928.9,-270.2l-0.1 -0.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    fillRule: "nonzero",
    d: "M7821.1 597.7c516.8,396.9 775.2,1129.8 775.2,2198.7 0,1068.9 -258.4,1804.5 -775.2,2206.6 -506.6,415.9 -1142.8,643.9 -1798.6,643.9 -26.3,0 -54,-0.3 -79.9,-1l-1349.4 0.1 0 -5641 1177.3 0c53.7,-2.4 109,-4 163.1,-4 675.4,0 1335.2,208.9 1887.6,596.9l-0.2 -0.2 0.1 0zm-2450 29.1l0 4405.3 629.7 0c23.2,0.7 47.3,1.3 70.7,1.3 449.9,0 882.7,-174.1 1207.2,-485.6 324.5,-320.9 487.6,-904.7 489.4,-1751.4 2,-44.8 3.1,-90.7 3.1,-135.8 0,-425.9 -91.4,-847.1 -267.6,-1234.8 -128.1,-275.7 -349.4,-498 -624.5,-627.1 -277.3,-106.9 -572.1,-162 -869.3,-162 -18.9,0 -38,0.3 -56.6,0.6l-582.2 -10.5 0.1 0z"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "black",
    fillRule: "nonzero",
    points: "9702.3,5646.1 9702.3,5 12700,5 12610,626.8 10493.3,626.8 10493.3,2550.3 12345.4,2550.3 12345.4,3164.1 10493.3,3164.2 10493.3,5646.1 "
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIc35);
export default __webpack_public_path__ + "static/media/ic_3_5.b28f74ad67f19a4e630c87669793920c.svg";
export { ForwardRef as ReactComponent };